<template>
  <div class="table-container">
    <vab-query-form>
      <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
        <!-- 国家名称 -->
        <el-form-item label="模版名称">
          <el-input placeholder="模版名称" v-model="queryForm.name" clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
            查询
          </el-button>
        </el-form-item>

        <el-form-item style="float: right">
          <el-button icon="el-icon-plus" type="primary" @click="handleAdd">
            添加
          </el-button>
        </el-form-item>
      </el-form>
    </vab-query-form>

    <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
      :height="height" border @selection-change="setSelectRows" @sort-change="tableSortChange">
      <el-table-column show-overflow-tooltip label="序号" width="120" align="center">
        <template #default="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <!-- 名称 -->
      <el-table-column show-overflow-tooltip prop="name" label="名称" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip prop="shipment_name" label="运送类型" align="center"></el-table-column>

      <!-- 首重 -->
      <el-table-column show-overflow-tooltip prop="first_number" label="首重" align="center"></el-table-column>

      <!-- 首重价格 -->
      <el-table-column show-overflow-tooltip prop="first_amount" label="首重价格" align="center"></el-table-column>

      <!-- 续重 -->
      <el-table-column show-overflow-tooltip prop="repeat_number" label="续重" align="center"></el-table-column>

      <!-- 续重价格 -->
      <el-table-column show-overflow-tooltip prop="repeat_amount" label="续重价格" align="center"></el-table-column>

      <el-table-column show-overflow-tooltip label="创建时间" prop="add_time" width="250" align="center"
        sortable></el-table-column>

      <el-table-column show-overflow-tooltip label="操作面板" width="150px" align="center">
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <!-- <el-button type="text" style="color: #ff0000" @click="handleDelete(row)">
                        删除
                    </el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="position: absolute; left: 0; right: 0; bottom: 20px; margin: auto" :background="background"
      :current-page="queryForm.page" :layout="layout" :page-sizes="[20, 40, 60, 100]" :page-size="queryForm.limit"
      :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
    <kor-postage ref="edit" @fetch-data="getnewlist"></kor-postage>
  </div>
</template>

<script>
  import korPostage from '../components/ydr_korPostage'
  import {
    ydr_admin_postage_list,
    ydr_admin_postage_detail,
    ydr_admin_postage_update
  } from '@/api/xgcApi'
  export default {
    name: 'ComprehensiveTable',
    components: {
      korPostage,
    },
    filters: {
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'gray',
          deleted: 'danger',
        }
        return statusMap[status]
      },
    },
    data() {
      return {
        form: {},
        imgShow: true,
        list: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        background: true,
        selectRows: '',
        elementLoadingText: '正在加载...',
        queryForm: {
          page: 1,
          limit: 20,
          name:'',
          kor_type:4
        },
        options1: [], //国家列表
        options: [],
        height: '73vh',
      }
    },
    computed: {},
    created() {
      this.fetchData()
      this.getCountryList()
    },

    beforeDestroy() {},
    mounted() {},
    methods: {
      // 获取国家列表
      getCountryList() {
        KorPic_country_list({
          limit: 200,
        }).then((res) => {
          this.options1 = res.data.list
        })
      },
      // 处理选项变化的方法
      handleChange(value) {
        // 在这里可以根据value执行查询操作
        this.getPicList(value)
        // 假设这是一个查询操作
      },

      getPicList(e) {
        KorPic_list({
          country_id: e
        }).then((res) => {
          this.options = res.data.list
        })
      },
      //初始化方法
      getnewlist() {
        this.fetchData()
      },
      tableSortChange() {
        const imageList = []
        this.$refs.tableSort.tableData.forEach((item, index) => {
          imageList.push(item.img)
        })
        this.imageList = imageList
      },
      setSelectRows(val) {
        this.selectRows = val
      },
      handleAdd() {
        this.$refs['edit'].showEdit()
      },
      handleEdit(row) {
        this.$refs['edit'].showEdit(row)
      },

      handleSizeChange(val) {
        this.queryForm.limit = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      handleQuery() {
        this.queryForm.page = 1
        this.fetchData()
      },

      fetchData() {
        this.listLoading = true
        ydr_admin_postage_list(this.queryForm).then(res => {
          var data = res.data
          this.list = data.list
          this.total = data.count
          this.listLoading = false
        })
      },
    },
  }
</script>

<style scoped>
  :deep .right-panel {
    display: flex;
    align-items: center;
  }

  .el-switch {
    height: auto !important;
  }
</style>
